import { AsyncGuarder } from 'components/AsyncGuarder/AsyncGuarder';

export function AsyncGuarderDecorator<A extends unknown[]>(
  target: object,
  propertyKey: string,
  descriptor: TypedPropertyDescriptor<(...args: A) => void | Promise<unknown>>,
): TypedPropertyDescriptor<(...args: A) => void | Promise<unknown>> {
  const originalMethod = descriptor.value!;
  const guarderKey = Symbol(propertyKey.toString());

  descriptor.value = function (this: object, ...args: A): void {
    const inst = this as Record<symbol, AsyncGuarder<unknown> | undefined>;
    let guard = inst[guarderKey];
    if (!guard) {
      guard = new AsyncGuarder<unknown>();
      inst[guarderKey] = guard;
    }
    guard.run(() => {
      try {
        const result = originalMethod.apply(this, args);
        return Promise.resolve(result);
      } catch (e) {
        return Promise.reject(e);
      }
    });
  } as (...args: A) => void;

  return descriptor;
}
